export default __webpack_public_path__ + "static/media/setting.1defd925.svg";